export enum BuildingType {
  SOLID = 'SOLID',
  NOT_SOLID = 'NOT_SOLID',
}

export const getBuildingTypeLabel = (value: BuildingType): string => {
  switch (value) {
    case BuildingType.SOLID:
      return $localize`Batiment solide`;
    case BuildingType.NOT_SOLID:
      return $localize`Batiment non solide`;
    default:
      return '';
  }
};
